import { isRouteErrorResponse } from "react-router";
import { z } from "zod";

/**
 * The page an error boundary renders for an error it has nothing more specific to say
 * about: the status and whatever the throwing route put in the Response body.
 */
export function RouteErrorPage({ error }: { error: unknown }) {
  let message = "Something went wrong";
  let details = "An unexpected error occurred.";

  if (isRouteErrorResponse(error)) {
    message = `${error.status} ${error.statusText}`;
    // Whatever the throwing route put in the Response body. Only a string is something
    // this page can render; anything else keeps the generic line above.
    const detail = z.string().safeParse(error.data);

    if (detail.success) details = detail.data;
  } else if (error instanceof Error) {
    details = error.message;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-2xl font-semibold">{message}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{details}</p>
        <a href="/" className="mt-4 inline-block text-sm text-primary underline">
          Return to Home
        </a>
      </div>
    </div>
  );
}
